import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { SecondMs } from 'rev-shared/date/Time.Constant';
import { UserContextService } from 'rev-shared/security/UserContext.Service';
import { noop } from 'rev-shared/util';

import { VideoReviewService } from './VideoReview.Service';

import styles from './VideoReview.module.less';

@Directive({})
export class VideoReviewEntryBase {
	@Input({ required: true }) public showHoursInTimestamp: boolean;
	@Input({ required: true }) public videoId: string;
	@Input({ required: true }) public isReadOnlyMode: boolean;
	@Output() public timeClicked = new EventEmitter<number>();

	public readonly styles = styles;
	public readonly SecondMs = SecondMs;
	public readonly noop = noop;

	public showReplyInput: boolean;
	public currentUserId: string;

	constructor(
		public elementRef: ElementRef,
		public VideoReviewService: VideoReviewService,
		public UserContextService: UserContextService,
		public DialogService: DialogService,
		public TranslateService: TranslateService
	) {
		this.currentUserId = UserContextService.getUser().id;
	}

	public onEntryClick(timestamp: number): void {
		this.timeClicked.emit(timestamp);
	}

	public onReplyClick(): void {
		this.showReplyInput = !this.showReplyInput;
	}

	public onHideReplyInput(): void {
		this.showReplyInput = false;
	}
}
